import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationComponent } from './registration.component';
import { RegistrationService } from './registration.service';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { KngLoaderModule, ModalModule, KngButtonModule, KngFooterModule } from 'kinetic-angular';
import { AnalyticsModule } from '../../services/analytics/analytics.module';
import { MatRadioModule } from '@angular/material/radio';
import{ SafeHtmlPipeModule } from '../../../app/pipes/safehtml/safehtml.pipe.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RegistrationProfileCompanyInformationComponent } from './sub-modules/registration-profile-company-information/registration-profile-company-information.component';
import { RegistrationAccountTypeComponent } from './sub-modules/registration-account-type/registration-account-type.component';
import { RegistrationTermsAndConditionsComponent } from './sub-modules/registration-terms-and-conditions/registration-terms-and-conditions.component';
import { RegistrationAdditionalLocationsComponent } from './sub-modules/registration-additional-locations/registration-additional-locations.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { KngUploadFileModule } from 'projects/kinetic-angular/src/lib/components/upload-file';

@NgModule({
	declarations: [ RegistrationComponent, RegistrationProfileCompanyInformationComponent, RegistrationAccountTypeComponent, RegistrationTermsAndConditionsComponent, RegistrationAdditionalLocationsComponent ],
	imports: [
		CommonModule,
		KngFooterModule,
		KngButtonModule,
		MatSelectModule,
		MatIconModule,
		ReactiveFormsModule,
		ModalModule,
		KngLoaderModule,
		AnalyticsModule,
		MatRadioModule,
		SafeHtmlPipeModule,
		MatCheckboxModule,
		FormsModule,
		NgxPaginationModule,
		KngUploadFileModule
	],
	exports: [RegistrationComponent],
	providers: [RegistrationService]
})
export class RegistrationModule {}
